import { assign } from 'xstate';

const handleRefund = assign((context, event) => {
  return { ...context, ...event.data };
});

export { handleRefund };
